import React, { useEffect, useState } from 'react';

/*
 * The console's scrollback, revealed a line at a time on mount. This is the
 * page's one piece of theatre, and it is theatre over real content: every line
 * is counted out of homelab.yaml, so the log claims nothing the data does not.
 *
 * Reduced motion gets the finished log immediately rather than a faster reveal.
 * The animation carries no information the static list does not already hold,
 * so there is nothing to preserve by speeding it up.
 */

const STEP = 90; // ms between lines; the whole log lands in under a second

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches === true;

const BootLog = ({ lines }) => {
  const [shown, setShown] = useState(() => (prefersReducedMotion() ? lines.length : 0));

  useEffect(() => {
    if (shown >= lines.length) return undefined;
    const timer = setTimeout(() => setShown((n) => Math.min(n + 1, lines.length)), STEP);
    return () => clearTimeout(timer);
  }, [shown, lines.length]);

  return (
    <ol className="boot-log">
      <li className="boot-line boot-line--head">
        <span className="boot-key">read</span>
        <span className="boot-val">/data/homelab.yaml</span>
      </li>
      {lines.slice(0, shown).map((line) => (
        <li className="boot-line" key={line.key}>
          <span className="boot-key">{line.key}</span>
          <span className="boot-val">{line.value}</span>
          <span className="boot-ok" aria-hidden="true">ok</span>
        </li>
      ))}
    </ol>
  );
};

export default BootLog;
